<template>
  <div class="clinic-provider-products">
    <show-provider-product ref="showproduct" @submit="loadProducts(1)"></show-provider-product>
    <!-- TITLE -->
    <div class="form-group row">
      <div class="col">
        <h1 class="page-title">MATERIALES</h1>
      </div>
    </div>
    <!-- SEARCH BAR -->
    <div class="form-group row">
      <div class="col-md-4">
        <input type="search" class="form-control icon" v-model="search" placeholder="Busca Materiales por nombre ...">
      </div>
      <div class="col-md-3">
        <select class="custom-select" v-model="provider_family_id" id="search_provider_family_id">
          <option :value="null">Todas</option>
          <option :value="family.id" v-for="family in families" :key="family.id">{{ family.name }}</option>
        </select>
        <label for="search_provider_family_id" class="wabident-info">Familia</label>
      </div>
      <div class="col-md-5">
        <button type="button" @click="onNewProduct" class="btn btn-wabident-round float-right">
          <i class="fas fa-plus"></i>
          Nuevo Material &hellip;
        </button>
      </div>
    </div>

    <!-- RESULTS -->
    <div v-if="has_results" class="form-group row">
      <div class="col-12">
        <table class="table table-search-results">
          <thead>
            <tr class="table-search-results__row">
              <th class="left">ID</th>
              <th class="left">NOMBRE</th>
              <th class="center">TIPO</th>
              <th class="center">FAMILIA</th>
              <th class="right">STOCK</th>
            </tr>
          </thead>
          <tbody>

            <tr class="table-search-results__row" v-for="product in results.data" :index="product.id"
              @click="$refs.showproduct.showEdit(product)">
              <td class="left">{{ product.id }}</td>
              <td class="left">{{ product.name }}</td>
              <td class="center">{{ typenames[product.type] || '' }}</td>
              <td class="center">{{ product.family ? product.family.name : '' }}</td>
              <td class="right">{{ Number(product.current_stock) }}</td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="col-12 my-4">
        <data-pagination :disabled="is_searching" @gotopage="loadProducts" :page="results.current_page"
          :total="results.last_page"></data-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      provider_family_id: null,
      results: null,
      is_searching: false,
      typenames: {
        physical: 'Físico',
        virtual: 'Virtual',
      }
    };
  },
  computed: {
    families() {
      return this.clinic ? this.clinic.provider_families : [];
    },
    has_results() {
      return this.results && this.results.data;
    },
    ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
  },
  watch: {
    provider_family_id(v) {
      this.loadProducts();
    },
    search(v) {
      this.loadProducts();
    },
  },
  methods: {
    loadProducts(page = 1) {
      if (this.is_searching) {
        return;
      }

      this.is_searching = true;
      const params = {
        search: this.search,
        page: page,
        provider_family_id: this.provider_family_id,
      };

      axios.get(`/clinic/${this.clinic.id}/provider_product`, { params }).then((response) => {
        this.results = response.data;
      }).catch((error) => {
        this.msgwindow.error('Error listando Materiales. Por favor, contacta con el Administrador');
      }).then(() => {
        this.is_searching = false;
      });
    },
    onNewProduct() {
      this.$refs.showproduct.showNew();
    },
  },
  mounted() {
    this.loadProducts();
  }
}
</script>

<style>
.clinic-provider-products {
  margin-top: 52px;
}
</style>
